import { Component, OnInit, ViewChild, ElementRef, NgZone } from '@angular/core';
import { AuthService } from '../_services/auth.service';
import { SpinnerService } from '../_core/spinner/spinner.service';
import { FormBuilder, FormGroup, FormControl, Validators, ValidatorFn, ValidationErrors, AbstractControl, FormGroupDirective, NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { UserDetailsDataForm } from '../_models/user-details-data-form';
import { UserDataService } from '../_services/user-data.service';
import { UserSessionDataForm } from '../_models/login/user-session-data-form';
import { LoaderService } from '../_core/loader/loader.service';
import { Subscription } from 'rxjs';
import { LoginForm } from '../_models/login-form';
import { ErrorStateMatcher } from '@angular/material';
import { ValidationErrorMessageEnum } from '../constants/ValidationErrorMessageEnum';
import { WhiteSpaceValidators } from '../shared/whitespace.validator';
import { ReCaptchaV3Service } from 'ngx-captcha';
/// <reference types="@types/googlemaps" />
import { MapsAPILoader } from '@agm/core';
import { OrganizationDataForm } from '../_models/organization-data-form';
declare var google: any;

// ===== ErrorStateMatcher =====
export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (isSubmitted));
  }
}

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit {
  userDetailsDataForm: UserDetailsDataForm = new UserDetailsDataForm();
  loginForm: LoginForm = new LoginForm();
  organizationDataForm: OrganizationDataForm = new OrganizationDataForm();
  userDetailsFormGroup: FormGroup;
  submitAttempt = false;
  checkUserSessionFlag = false;
  mathProblem: string;

  userDataSession;
  userDisplayName = '';
  userRoleId = 0;
  userRoleName = '';
  hidePassword = true;
  hideConfirmPassword = true;
  acceptTermAndCon = false;
  // For Local 
   siteKey= '6LeYKL8pAAAAADeBd-_vzlsoiluWO4e4OszsoRHg';
  // For live 
 // siteKey: any = '6LcyBIUUAAAAAJ1TXao2wL8DlpgSE41j4EgXGA9o';
  reCaptchaToken = '';
  userNameAlreadyExitsFlag = true;
  mobileNumberValidState: boolean = true;

  @ViewChild('autoComplete') public searchElementRef: ElementRef;
  @ViewChild('firstName') firstNameRef: ElementRef;

  constructor(
    private authService: AuthService,
    public loaderService: LoaderService,
    private formbuilder: FormBuilder,
    private router: Router,
    private userDataService: UserDataService,
    private reCaptchaV3Service: ReCaptchaV3Service,
    private spinnerService: SpinnerService,
    private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone
  ) { }

  ngOnInit() {
    this.generateMathProblem();
    this.registerFormValidate();
    this.getCurrentUserDetails();
    this.recaptcha();

    //===== Auto complete =====
    this.mapsAPILoader.load().then(() => {
      let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement, {
        types: ["establishment"]
      });
      autocomplete.addListener("place_changed", () => {
        this.ngZone.run(() => {
          const place = autocomplete.getPlace();
          this.organizationDataForm.organizationName = place.name;
          this.organizationDataForm.addressLineOne = place.formatted_address;
          this.organizationDataForm.webSite = place.website;
          this.organizationDataForm.phoneNumber = place.international_phone_number;
          for (let i in place.address_components) {
            const exactType = place.address_components[i].types[0];
            if (exactType == 'sublocality_level_1') {
              this.organizationDataForm.addressLineTwo = place.address_components[i].long_name;
            }
            if (exactType == 'locality') {
              this.organizationDataForm.city = place.address_components[i].long_name;
            }
            if (exactType == 'administrative_area_level_1') {
              this.organizationDataForm.state = place.address_components[i].long_name;
            }
            if (exactType == 'country') {
              this.organizationDataForm.countryName = place.address_components[i].long_name;
            }
            if (exactType == 'postal_code') {
              this.organizationDataForm.zipCode = place.address_components[i].long_name;
            }
          }
        });
      });
    });
  }
  generateMathProblem() {
    const num1 = Math.floor(Math.random() * 10) + 1;
    const num2 = Math.floor(Math.random() * 10) + 1;
    this.mathProblem = `${num1} + ${num2}`;
  }

  recaptcha(): void {
    this.reCaptchaV3Service.execute(this.siteKey, 'homepage', (token) => {
      this.reCaptchaToken = token;
    },
    );
  }

  registerFormValidate() {
    const mobnumPattern = "^[0-9+]*$";
    const namePattern = "^[A-Za-z\\s-]+$";
    const emailPattern = "[[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$";
    this.userDetailsFormGroup = this.formbuilder.group({
      firstName: ['', [Validators.required, Validators.pattern(namePattern), WhiteSpaceValidators.emptySpace()]],
      lastName: ['', [Validators.required, Validators.pattern(namePattern), WhiteSpaceValidators.emptySpace()]],
      mobileNo: ['', [Validators.required, Validators.pattern(mobnumPattern)]],
      userName: ['', [Validators.required, Validators.pattern(emailPattern), WhiteSpaceValidators.emptySpace()]],
      designation: [''],
      organization: ['', [Validators.required, WhiteSpaceValidators.emptySpace()]],
      password: ['', [Validators.required, Validators.minLength(5)]],
      confirmPassword: ['', [Validators.required, this.compareValidator('password')]],
      termsAndCon: ['', [Validators.required]],
      userRole: ['', [Validators.maxLength(100)]],
      'mathAnswer': ['', [
        Validators.required,
        this.mathValidation.bind(this) // Ensure correct context
      ]],
      'honeypot': ['']
    });

  }
  mathValidation(control) {
    const mathAnswer = Number(control.value);
    const answer = eval(this.mathProblem);
    if (mathAnswer !== answer) {
      return { mathAnswer: true };
    }
    return null;
}

  getNumber(fullPhone: any) {
    this.userDetailsDataForm.mobileNo = fullPhone;
  }

  hasError(errorState) {
    this.mobileNumberValidState = errorState;
  }

  getErrorMsgForUserDetasilsFormFirstName() {
    return this.userDetailsFormGroup.controls.firstName.errors.required ? ValidationErrorMessageEnum.REQUIRED :
      this.userDetailsFormGroup.controls.firstName.errors.minlength ? ValidationErrorMessageEnum.MIN_LENGTH_THREE :
        this.userDetailsFormGroup.controls.firstName.errors.pattern ? ValidationErrorMessageEnum.ALPHABET :
          this.userDetailsFormGroup.controls.firstName.errors.whitespace ? ValidationErrorMessageEnum.REQUIRED :
            '';
  }

  getErrorMsgForUserDetasilsFormLastName() {
    return this.userDetailsFormGroup.controls.lastName.errors.required ? ValidationErrorMessageEnum.REQUIRED :
      this.userDetailsFormGroup.controls.lastName.errors.minlength ? ValidationErrorMessageEnum.MIN_LENGTH_ONE :
        this.userDetailsFormGroup.controls.lastName.errors.pattern ? ValidationErrorMessageEnum.ALPHABET :
          this.userDetailsFormGroup.controls.lastName.errors.whitespace ? ValidationErrorMessageEnum.REQUIRED :
            '';
  }

  getErrorMsgForUserDetasilsFormOrganization() {
    return this.userDetailsFormGroup.controls.organization.errors.required ? ValidationErrorMessageEnum.REQUIRED :
      this.userDetailsFormGroup.controls.organization.errors.pattern ? ValidationErrorMessageEnum.ALPHABET :
        this.userDetailsFormGroup.controls.organization.errors.whitespace ? ValidationErrorMessageEnum.REQUIRED :
          '';
  }

  getErrorMsgForTermsAndCondition() {
    return this.userDetailsFormGroup.controls.termsAndCon.errors.required ? ValidationErrorMessageEnum.TERMS_AND_COND :
      ''
  }

  getErrorMsgForUserDetasilsFormEmail() {
    return this.userDetailsFormGroup.controls.userName.errors.required ? ValidationErrorMessageEnum.REQUIRED :
      this.userDetailsFormGroup.controls.userName.errors.pattern ? ValidationErrorMessageEnum.VALID_EMAIL :
        this.userDetailsFormGroup.controls.userName.errors.whitespace ? ValidationErrorMessageEnum.REQUIRED :
          '';
  }

  getErrorMsgForUserDetasilsFormPassWord() {
    return this.userDetailsFormGroup.controls.password.errors.required ? ValidationErrorMessageEnum.REQUIRED :
      this.userDetailsFormGroup.controls.password.errors.minlength ? ValidationErrorMessageEnum.MIN_LENGTH_FIVE :
        '';
  }

  getErrorMsgForUserDetasilsFormMobile() {
    return this.userDetailsFormGroup.controls.mobileNo.errors.required ? ValidationErrorMessageEnum.REQUIRED :
      this.userDetailsFormGroup.controls.mobileNo.errors.length ? ValidationErrorMessageEnum.VALID_MOBILE :
        '';
  }

  getCurrentUserDetails() {
    this.authService.checkUserSession();
    const currentUser = localStorage.getItem('currentUser');
    const currentUserJson: UserSessionDataForm = JSON.parse(currentUser);
    if (currentUserJson != null) {
      this.userDataSession = currentUserJson;
      this.userRoleId = this.userDataSession.userRoleId;
      if (this.userRoleId === 1) {
        this.userDetailsDataForm.userRole = "Admin";
      } else {
        this.userDetailsDataForm.userRole = "User";
      }

      if (this.userDataSession.fullName) {
        this.userDisplayName = this.userDataSession.fullName;
      } else if (this.userDataSession.emailId) {
        this.userDisplayName = this.userDataSession.emailId;
      } else if (this.userDataSession.userId) {
        this.userDisplayName = this.userDataSession.userId;
      }
      this.userRoleName = this.userDataSession.userRoleName;
    } else {
      this.router.navigate(['/register']);
    }
  }

  registerUser() {
    if (this.userDetailsFormGroup.valid && this.acceptTermAndCon == true && this.mobileNumberValidState == true&& this.userDetailsFormGroup.get('honeypot').value === '') {
      this.userDetailsDataForm.reCaptchaToken = this.reCaptchaToken;
      this.userDetailsDataForm.organizationDetails = this.organizationDataForm;
      this.spinnerService.show();
      this.loaderService.show();
      this.userDataService.saveUserDetails(this.userDetailsDataForm).subscribe(
        resp => {
          this.spinnerService.hide();
          this.loaderService.hide();
          this.router.navigate(['/login']);
        }, error => {
          if (error.error.error.message == 'That username is taken. Try another.') {
            this.userNameAlreadyExitsFlag = false;
          }
          this.spinnerService.hide();
          this.loaderService.hide();
          this.router.navigate(['/register']);
        })
    }
    else {
      this.userDetailsFormGroup.markAsTouched();
      for (let inner in this.userDetailsFormGroup.controls) {
        this.userDetailsFormGroup.get(inner).markAsTouched();
        this.userDetailsFormGroup.get(inner).updateValueAndValidity();
      }
    }
  }

  compareValidator(controlNameToCompare: string): ValidatorFn {
    return (c: AbstractControl): ValidationErrors | null => {
      if (c.value === null || c.value.length === 0) {
        return null;
      }
      const controlToCompare = c.root.get(controlNameToCompare);
      if (controlToCompare) {
        const subscription: Subscription = controlToCompare.valueChanges.subscribe(() => {
          c.updateValueAndValidity();
          subscription.unsubscribe();
        });
      }
      return controlToCompare && controlToCompare.value !== c.value ? { 'compare': true } : null;
    };
  }
  matcher = new MyErrorStateMatcher();
}

